import Vue from 'vue'
import Router from 'vue-router'
import Web from '@/pages/web'

import Me from '@/pages/me'
import server from '@/pages/server'
import laboratory from '@/pages/laboratory'
import company from '@/pages/company'
import errmessage from '@/pages/errmessage'
import reportmessage from '@/pages/reportmessage'
import news from '@/pages/news'
import Lab from './modules/lab'
import Sso from '@/pages/sso'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/web'
    },
    {
      path: '/sso',
      name:'sso', 
      component:Sso,
    },
    {
      path:'/web',
      name:'web', 
      component:Web,
    },


    {
      path:'/me',
      name:'me',
      component:Me
    },
    {
      path:'/server',
      name:'server',
      component:server
    },
    {
      path:'/laboratory',
      name:'laboratory',
      component:laboratory
    },
    {
      path:'/company',
      name:'company',
      component:company
    },
    
    
    {
      path: '/errmessage',
      name: 'errmessage',
      component: errmessage
    },
    {
      path: '/reportmessage',
      name: 'reportmessage',
      component: reportmessage
    },
    {
      path:'/news',
      name:'news',
      component:news
    },
    ...Lab,
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js